<app-form-field label="Entités" [control]="formControl"
  required
  [desktopSize]="4"
  [ngClass]="{'is-hidden': isHidden}">
  <select class="select" [formControl]="formControl">
    @for (entite of entitesVisibles; track entite) {
      <option [ngClass]="{'is-readonly': !entite.editable}" [ngValue]="entite.id">{{entite.libelle}}</option>
    }
  </select>
</app-form-field>
